export const APP_LOGIN = "app/LoginPage/APP_LOGIN";
export const APP_LOGIN_SUCCESS = "app/LoginPage/APP_LOGIN_SUCCESS";
export const APP_LOGIN_FAILURE = "app/LoginPage/APP_LOGIN_FAILURE";

export const RESET_TO_INITIAL_STATE = "app/LoginPage/RESET_TO_INITIAL_STATE"